export function Footer({ children }) {
  return <footer>{children}</footer>;
}
